module.exports = __webpack_public_path__ + "img/37_154.954225ae.png";